/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import './style.scss';

interface IProps {
    icon?: React.ReactNode;
    size?: number;
    className?: string;
    onClick?: (e: any) => void;
    disabled?: boolean;
}

const IconWrap: React.FC<IProps> = ({ icon, className, size, onClick, disabled = false }) => {
    return (
        <div
            className={`${className} icon__wrap ${disabled ? 'disabled-icon' : ''}`}
            style={{ fontSize: size }}
            onClick={onClick}
        >
            {icon}
        </div>
    );
};

export default React.memo(IconWrap);
